import {
  Box,
  Chip,
  LinearProgress,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AgGridTable from "../../../components/table/AgGridTable";
import { ColDef } from "ag-grid-community";

import { useEffect, useState } from "react";
import axiosInstance from "../../../axios/axios";
import True from "../../../assets/baseVersion/True_img.svg";
import False from "../../../assets/baseVersion/False_img.svg";
import Not_Applicable from "../../../assets/baseVersion/NotApplicable.svg";
import { useNavigate } from "react-router-dom";
import LaunchSharpIcon from "@mui/icons-material/LaunchSharp";
import Exclamation from "../../../assets/Exclamation.png";
import AcceptedRisk_False from "../../../assets/accepted_risk_false.svg";

const CloudMisconfiguration = ({ setDrawerOpen }: any) => {
  const [rowData, setRowData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const module = "cloud";

  const fetchData = async () => {
    setIsLoading(true);
    setIsReady(false);
    try {
      const response = await axiosInstance.get(
        `securityscan/security-info?module=${module}`
      );
      if (response.data?.data) {
        const formattedData = response.data.data.map((control: any) => ({
          id: control.id,
          type: `${control.param_name} - ${control.device_type}`,
          controls: `${control.param_name}`,
          asset_count: control.asset_count,
          compliance_passed_count: control.passed_asset_count,
          compliance_failed_count: control.compliance_failed_count,
          accepted_count: control.accepted_count,
          compliance_count: control.asset_passed_percent,
          tag_name: control.tag_name,
          parameter_type: control.parameter_type,
          severity: control.highest_priority,
          control_type: control.control_type,
          total_Count: control.total_asset_count,
          failed_asset_count: control.failed_asset_count,
          passed_asset_count: control.passed_asset_count,
          not_applicable_asset_count: control.not_applicable_asset_count,
        }));

        setRowData(formattedData);
        setIsReady(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setRowData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const columnDefs: ColDef[] = [
    // {
    //   field: "id",
    //   headerName: "#s",
    //   maxWidth: 70,
    //   valueGetter: (params: any) => params.node.rowIndex + 1,
    // },

    {
      field: "controls",
      headerName: "Recommendation",
      filter: false,
      sortable: false,
      minWidth: 280,
      width: 280,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const parameterType = params.data?.parameter_type || "";
        const isManual = parameterType === "Manual";
        // const color = isManual ? "#F7941F" : "#696595";
        const color = isManual
          ? isDarkMode
            ? "#FFB74D"
            : "#F7941F"
          : isDarkMode
          ? "#B2B2FF"
          : "#696595";
        const bgcolor = isManual ? "#F7941F" : "#696595";

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: 8,
            }}
          >
            <Tooltip
              title={value}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  flex: 1,
                }}
              >
                {value}
              </Typography>
            </Tooltip>
            {/* {parameterType && (
              <Chip
                label={parameterType}
                variant="outlined"
                size="small"
                sx={{
                  borderRadius: 1,
                  border: `1px solid ${bgcolor}`,
                  // bgcolor: "white",
                  color: color,
                  fontWeight: "bold",
                  ml: 1,
                }}
              />
            )} */}
          </div>
        );
      },
    },

    // {
    //   field: "tag_name",
    //   headerName: "Tags",
    //   filter: true,
    //   minWidth: 240,
    //   cellRenderer: (params: any) => {
    //     const getRandomColor = () => {
    //       const hue = Math.floor(Math.random() * 360);
    //       return {
    //         background: `hsl(${hue}, 70%, 80%)`,
    //         color: `hsl(${hue}, 50%, 20%)`,
    //       };
    //     };

    //     const tagString = params.data?.tag_name;
    //     const tagsArray = tagString.split(",").map((tag: any) => tag.trim());

    //     const visibleTags = tagsArray.slice(0, 1);
    //     const hiddenTags = tagsArray.slice(1);

    //     // Capitalize first letter utility
    //     const capitalize = (str: string) =>
    //       str.charAt(0).toUpperCase() + str.slice(1);

    //     return (
    //       <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
    //         {visibleTags.map((tag: string, index: number) => {
    //           // Apply specific styles to first and second tag
    //           let style = {};
    //           if (index === 0) {
    //             style = {
    //               backgroundColor: "#0183191A",
    //               color: "#018319",
    //             };
    //           } else if (index === 1) {
    //             style = {
    //               backgroundColor: "#894B001A",
    //               color: "#894B00",
    //             };
    //           } else {
    //             const random = getRandomColor();
    //             style = {
    //               backgroundColor: random.background,
    //               color: random.color,
    //             };
    //           }

    //           return (
    //             <Chip
    //               key={index}
    //               size="small"
    //               label={capitalize(tag)}
    //               style={{
    //                 ...style,
    //                 fontWeight: "bold",
    //                 borderRadius: 4,
    //               }}
    //             />
    //           );
    //         })}

    //         {hiddenTags.length > 0 && (
    //           <Tooltip title={hiddenTags.join(", ")} arrow placement="top">
    //             <Chip
    //               size="small"
    //               variant="outlined"
    //               label={`+${hiddenTags.length}`}
    //               style={{
    //                 fontWeight: "bold",
    //                 borderRadius: 4,
    //                 border: "1px solid #BEBED1",
    //               }}
    //             />
    //           </Tooltip>
    //         )}
    //       </div>
    //     );
    //   },
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },

    // {
    //   field: "control_type",
    //   headerName: "Benchmark",
    //   filter: true,
    //   minWidth: 150,
    //   width: 200,
    //   cellClass: "custom-cell",
    //   cellRenderer: (params: any) => (
    //     <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
    //       {params.value?.includes("SPARK") && (
    //         <img
    //           src={isDarkMode ? spark_dark : sparkLogo}
    //           alt="spark"
    //           height="24"
    //         />
    //       )}
    //       {params.value?.includes("CIS") && (
    //         <img
    //           src={isDarkMode ? cis_dark : cis_light}
    //           alt="cis"
    //           height="24"
    //         />
    //       )}
    //       {params.value?.includes("NIST") && (
    //         <img
    //           src={isDarkMode ? nist_dark : nistLogo}
    //           alt="nist"
    //           height="12"
    //         />
    //       )}
    //     </Box>
    //   ),
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },

    {
      field: "severity",
      headerName: "Severity",
      filter: true,
      sortable: true,
      minWidth: 130,
      width: 130,
      cellRenderer: (params: any) => {
        const severityStyles: any = {
          Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
              color: severityStyles[params.value]?.color || "#666666",
              height: "20px",
              borderRadius: "4px",
              position: "relative",
              fontWeight: 600,
              p: 1.5,
              pr: 0,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                width: 8,
                height: 8,
                bgcolor: severityStyles[params.value]?.color || "#666666",
                borderRadius: "50%",
              },
              "& .MuiChip-label": { px: 1 },
            }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "accepted_count",
      headerName: "Risk Accepted",
      filter: true,
      minWidth: 160,
      width: 160,
      cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (
          <img
            src={AcceptedRisk_False}
            alt="warning"
            style={{ height: "20px" }}
          />
        ),
    },

    {
      field: "compliance_count",
      headerName: "Resources",
      width: 150,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params: any) => {
        const passedCount = params.data.compliance_passed_count;
        const compliance_count = params.data.total_Count;
        const rawValue = params.value || 0;
        const data = params.data;
        const progressValue = Number(rawValue.toFixed(2));
        const STATUS_CONFIG = {
          passed_asset_count: { label: "Pass", icon: True },
          failed_asset_count: { label: "Fail", icon: False },
          not_applicable_asset_count: {
            label: "Not Applicable",
            icon: Not_Applicable,
          },
        };
        const availableStatuses = Object.entries(STATUS_CONFIG)
          .filter(([key]) => data[key] != null && data[key] > 0)
          .map(([key, config]) => ({
            ...config,
            count: data[key],
            key,
          }));

        const total = availableStatuses.reduce((sum, s) => sum + s.count, 0);
        const passed = data.passed_asset_count || 0;
        const passPercent =
          total > 0 ? ((passed / total) * 100).toFixed(2) : "0.00";

        const tooltipContent =
          availableStatuses.length > 0 ? (
            <Box sx={{ p: 1, width: 200 }}>
              {availableStatuses.map((status) => (
                <Box
                  key={status.key}
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                >
                  <img
                    src={status.icon}
                    alt={status.label}
                    style={{ width: 20, height: 20 }}
                  />
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    sx={{ flexGrow: 1 }}
                  >
                    {status.label}
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {status.count}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ p: 1 }}>
              <Typography variant="body2">No data available</Typography>
            </Box>
          );

        return (
          <Tooltip
            title={tooltipContent}
            arrow
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "preventOverflow",
                    options: {
                      boundary: "window",
                    },
                  },
                ],
              },
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #ddd",
                  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                  fontSize: "14px",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="caption">
                  {`${passedCount}/${compliance_count} (${progressValue}%)`}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={progressValue}
                sx={{
                  height: 6,
                  borderRadius: 3,
                  bgcolor: "#f5f5f5",
                  "& .MuiLinearProgress-bar": {
                    bgcolor:
                      progressValue >= 70
                        ? "#4caf50"
                        : progressValue >= 40
                        ? "#ff9800"
                        : "#f44336",
                  },
                }}
              />
            </Box>
          </Tooltip>
        );
      },
    },
  ];
  const navigate = useNavigate();
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
            alignItems: "center",
          }}
        >
          {" "}
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", fontSize: "18px" }}
          >
            Cloud Security Posture 
          </Typography>
          <LaunchSharpIcon
            sx={{
              color: isDarkMode ? "white" : "black",
              cursor: "pointer",
              fontSize: "20px",
            }}
            onClick={() => navigate("/cloud/security-posture")}
          ></LaunchSharpIcon>
        </div>
        <CancelIcon
          onClick={() => setDrawerOpen(false)}
          sx={{ cursor: "pointer" }}
        />
      </div>
      <AgGridTable
        columnDefs={columnDefs}
        data={rowData}
        showSearch
        isRowSelectable
        height={"calc(100vh - 92px)"}
        //   onRowClick={handleOnRowClick}
        isLoading={!isReady || isLoading}
      />
    </div>
  );
};

export default CloudMisconfiguration;
